import { ReactElement } from 'react'
import { Button } from '@mui/material'
import type { ShearConnectionDTO } from '@api/fastAPI.schemas'
import { SaveButton } from '@ui/actions'
import { DialogBase } from '@ui/feedback'
import ShearConnectionForm from '../ShearConnectionForm'

const FORM_ID = 'shear-connection-create-form'

interface Props {
  open: boolean
  onClose: () => void
  connection: ShearConnectionDTO
  takenShortNames: string[]
  isSaving: boolean
  onSave: (values: ShearConnectionDTO) => Promise<unknown>
}

const CreateShearConnectionDialog = ({
  open,
  onClose,
  connection,
  takenShortNames,
  isSaving,
  onSave,
}: Props): ReactElement => {
  const handleSubmit = async (data: ShearConnectionDTO) => {
    await onSave(data)
    onClose()
  }

  return (
    <DialogBase
      open={open}
      onClose={onClose}
      title="Neuen Schubverbinder erstellen"
      dialogProps={{ fullWidth: true }}
    >
      <ShearConnectionForm
        defaultValues={connection}
        id={FORM_ID}
        onSubmit={handleSubmit}
        takenShortNames={takenShortNames}
      />
      <>
        <Button size="small" onClick={onClose}>
          Abbrechen
        </Button>
        <SaveButton
          loading={isSaving}
          form={FORM_ID}
          type="submit"
          data-cy="create-shear-connection-btn"
        >
          Speichern
        </SaveButton>
      </>
    </DialogBase>
  )
}

export default CreateShearConnectionDialog
